import { htcmdService } from 'js/services/htcmd.service';
import { useAuthSelector, useUserSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useEffect, useState } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';

export const useNativeLogoutTrigger = () => {
    const {
        isLogoutManual,
        isLogoutInProcess,
        isLoginInProcess
    } = useAuthSelector(pick(['isLogoutManual', 'isLogoutInProcess', 'isLoginInProcess']));
    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const prevIsLogoutInProcess = usePrevious(isLogoutInProcess);
    const prevIsLoginInProcess = usePrevious(isLoginInProcess);
    const [wasLoggedIn, setWasLoggedIn] = useState(false);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            // don't do in web
            return;
        }

        if (!prevIsLogoutInProcess && isLogoutInProcess) {
            // only happens after logout has finished
            htcmdService.logout(isLogoutManual ? 'manual' : 'automatic');
            setWasLoggedIn(false);
        }
    }, [
        isLogoutManual,
        isLogoutInProcess,
        prevIsLogoutInProcess
    ]);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            // don't do in web
            return;
        }

        if (prevIsLoginInProcess && !isLoginInProcess && wasLoggedIn) {
            htcmdService.logout('terminated');
            setWasLoggedIn(false);
        }
    }, [
        isLoginInProcess,
        prevIsLoginInProcess,
        wasLoggedIn
    ]);

    /** this has to be the last item */
    useEffect(() => {
        if (isLoggedIn && prevIsLoginInProcess && !isLoginInProcess) {
            setWasLoggedIn(isLoggedIn);
        }
    }, [
        isLoggedIn,
        prevIsLoginInProcess,
        isLoginInProcess
    ]);
};
